// src/MaintenancePage.js

import React from 'react';
import logo from '../assets/images/Masroor Academy Logo 2.png'; // Add the academy logo in the src folder

const MaintenancePage = () => {
  return (
    <div className="maintenance-container text-center">
      <img src={logo} alt="Masroor Academy Victoria" className="logo" />
      <h1>We'll be back soon!</h1>
      <p>
        Sorry for the inconvenience but we're performing some maintenance at the moment. 
        We'll be back online shortly!
      </p>
      <p>
        — Masroor Academy Victoria Team
      </p>
      <div className="contact-info">
        <p>For any inquiries, please contact us at:</p>
        <p><a href="mailto:masrooracademyvic1@gmail.com">masrooracademyvic1@gmail.com</a></p>
      </div>
    </div>
  );
}

export default MaintenancePage;
